import { type LucideProps } from "lucide-react";

/**
 * Provides standard icon properties for icon components.
 * Destructures props and applies default values for size and className.
 */
export function getStandardSize24IconProps(props: LucideProps) {
  // oxlint-disable-next-line react/prop-types -- This is needed to size the icon.
  const {
    // oxlint-disable-next-line react/prop-types -- This is needed to color the icon.
    color = "currentColor",
    // oxlint-disable-next-line react/prop-types -- This is needed to size the icon.
    size = 24,
    // oxlint-disable-next-line react/prop-types -- This is needed to style the icon.
    strokeWidth = 2,
    // absoluteStrokeWidth,
    // oxlint-disable-next-line react/prop-types -- This is needed to style the icon.
    className = "",
    ...rest
  } = props;
  return { size, className, color, strokeWidth, ...rest };
}

export const defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};
